import React, { useRef, useState } from "react";

import classNames from "classnames";
// import Image from "next/image";
// import Link from "next/link";
// import { CarouselProvider, Slide, Slider } from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";

// import { ProductData } from "data/product/products";
import { CreatorSocialAccounts, StorefrontData } from "data/storefront";
// import { CircleCheckIcon } from "studio-design-system";
import { theme } from "studio-design-system";

// import { WhoIsAuthor, Video } from "data/videoProductPage";
// import { useWindowSize } from "usehooks-ts";
// import { useStorefrontWithProducts } from "~/api/storefrontApi";
import { CreatorCheck } from "~/components/common/CreatorInfo/CreatorCheck";
// import { CarouselButtonNextIcon } from "~/components/common/Icons/CarouselButtonNextIcon";
// import { CarouselButtonPreviousIcon } from "~/components/common/Icons/CarouselButtonPreviousIcon";
// import { InstagramIcon } from "~/components/common/Icons/InstagramIcon";
import InstagramIcon from "~/components/common/Icons/InstagramIcon";
// import { SpotifyIcon } from "~/components/common/Icons/SpotifyIcon";
import { SpotifyIcon } from "~/components/common/Icons/SpotifyIcon";
// import { TikTokIcon } from "~/components/common/Icons/TikTokIcon";
import TiktokIconNew from "~/components/common/Icons/TiktokIconNew";
// import { TwitterIcon } from "~/components/common/Icons/TwitterIcon";
import TwitterIconNew from "~/components/common/Icons/TwitterIconNew";
import { YouTubeIcon } from "~/components/common/Icons/YouTubeIcon";
// import { YouTubeIcon } from "~/components/common/Icons/YouTubeIcon";
// import { ImageWithBlur } from "~/components/common/ImageWithBlur/ImageWithBlur";
import { ProfilePic } from "~/components/common/ProfilePic";
// import { useIsInViewport } from "~/components/music/hooks/useIsInViewport";
// import { VideoCard } from "~/components/videoProductPage/components/WhoIsAuthor/VideoCard/VideoCard";
// import { VideoCard } from "~/components/storefront/VideoCard";
// import { sortProductsByIndex } from "~/components/storefront/utils/videoCardUtils";
import * as productStyles from "~/components/videoProductPage/Product.css";
// import { visibleVideosSlidesForDevice } from "~/components/videoProductPage/utils";
// import { checkLineNumber } from "~/components/videoProductPage/utils/checkLineNumber";
// import { useIsMobileScreen } from "~/hooks/ui/useIsMobileScreen";
import { useCreatorEditing, CreatorSavingType, errorBorderStyle } from "~/hooks/useCreatorEditing";

// import { getProductSlug, formatDateOnlyYear, formatMoney } from "~/util/stringUtils";
import * as styles from "./WhoIsAuthor.css";
import { ImageWithBlur } from "~/components/common/ImageWithBlur/ImageWithBlur";

const socialsInfo = {
  instagramAccount: {
    // icon: "https://res.cloudinary.com/monthly/image/upload/v1683032324/monthly-admin-images/icons/Instagram_-_Negative_nankls.svg",
    icon: InstagramIcon,
    prefixUrl: "https://instagram.com/",
    domain: "instagram.com",
  },
  spotifyAccountLink: {
    // icon: "https://res.cloudinary.com/monthly/image/upload/v1683032324/monthly-admin-images/icons/Spotify_-_Negative_pi2kdk.svg",
    icon: SpotifyIcon,
    prefixUrl: "https://open.spotify.com/user/",
    domain: "spotify.com",
  },
  youtubeAccountLink: {
    // icon: "https://res.cloudinary.com/monthly/image/upload/v1683032324/monthly-admin-images/icons/YouTube_-_Negative_mm30rc.svg",
    icon: YouTubeIcon,
    prefixUrl: "https://www.youtube.com/channel/",
    domain: "youtube.com",
  },
  twitterAccount: {
    // icon: "https://res.cloudinary.com/monthly/image/upload/v1683032325/monthly-admin-images/icons/Twitter_-_Negative_kodi0o.svg",
    icon: TwitterIconNew,
    prefixUrl: "https://twitter.com/",
    domain: "twitter.com",
  },
  tiktokAccount: {
    // icon: "https://res.cloudinary.com/monthly/image/upload/v1683032324/monthly-admin-images/icons/TikTok_-_Negative_qbsdtb.svg",
    icon: TiktokIconNew,
    prefixUrl: "https://www.tiktok.com/@",
    domain: "tiktok.com",
  },
};

export const ICON_COLORS = {
  BLACK: "#000",
  WHITE: "#fff",
};

export const WhoIsAuthorSection = ({
  // productData,
  storefrontData,
  isInEditMode,
  iconColor = ICON_COLORS.BLACK,
  authorShortDesColor = theme.colors.content.secondary,
}: // setIsSavingChanges,
  // setSavingStatusText,
  {
    // productData: ProductData;
    storefrontData: StorefrontData;
    isInEditMode: boolean;
    iconColor?: string;
    authorShortDesColor?: string;
    // setIsSavingChanges: (isSaving: boolean) => void;
    // setSavingStatusText: (statusText: string) => void;
  }) => {
  const { fieldsTexts, fieldsOnError, handleTextChange, handleTextEdit } = useCreatorEditing();
  const [showMore, setShowMore] = useState(false);
  // const [lineNumber, setLineNumber] = useState(0);
  const textBlockRef = useRef<HTMLParagraphElement>(null);
  // const [truncatedText, setTruncatedText] = useState({
  //   content: storefrontData.description,
  //   truncated: false,
  // });

  const handleCLick = () => {
    setShowMore(!showMore);
  };

  // const { width } = useWindowSize();
  // const isMobileScreen = useIsMobileScreen();
  // const MAX_LINES = isMobileScreen ? 6 : 9;
  // const [currentSlide, setCurrentSlide] = useState(-1);
  // let lastCardContainerRef = useRef<HTMLDivElement>(null);
  // let isLastCardVisible = useIsInViewport(lastCardContainerRef);

  // const isLastCardVisibleMobile =
  //   storefrontData &&
  //   storefrontData.products &&
  //   storefrontData.products.length ===
  //     currentSlide + Math.ceil(visibleVideosSlidesForDevice(width));

  // const productsLength = storefrontData?.products?.length || 0;

  // const shouldShowNextArrow = width > 650 ? productsLength >= 3 : productsLength >= 2;

  // const onCLickSlider = () => {
  //   console.log("slider click");
  // };

  // useEffect(() => {
  //   setLineNumber(checkLineNumber(textBlockRef.current, storefrontData.description || ""));
  // }, [width]);

  // useEffect(() => {
  //   if (lineNumber <= MAX_LINES) {
  //     setTruncatedText({ content: storefrontData.description, truncated: false });
  //     setShowMore(false);
  //     return;
  //   }

  //   if (!textBlockRef.current) return;

  //   setShowMore(true);
  //   const textNode = textBlockRef.current;
  //   textNode.textContent = storefrontData.description || "";
  //   const { offsetHeight } = textNode;
  //   const lineHeight = parseFloat(getComputedStyle(textNode).lineHeight || "0");
  //   const maxHeight = MAX_LINES * lineHeight;

  //   if (offsetHeight > maxHeight && storefrontData.description) {
  //     let words = storefrontData.description.split(" ");
  //     let tempText = "";

  //     while (textNode.offsetHeight > maxHeight) {
  //       words.pop();
  //       tempText = words.join(" ") + "...";
  //       textNode.innerText = tempText;
  //     }

  //     words = words.slice(0, words.length - 5);

  //     tempText = words.join(" ") + "...";

  //     setTruncatedText({ content: tempText, truncated: true });
  //   }
  // }, [lineNumber]);

  // const mainProductId = productData.id;
  // let products = storefrontData?.products?.sort(sortProductsByIndex);
  // products = [
  //   ...products?.filter((element) => element.id !== mainProductId),
  //   ...products?.filter((element) => element.id === mainProductId),
  // ];

  return (
    <section className={styles.authorSection}>
      <div className={styles.authorInfo}>
        <div className={styles.authorImgBlock}>
          <div className={styles.imageContainer}>
            <ImageWithBlur
              alt={"Instructor Image"}
              src={storefrontData.welcomePosterImageURL}
              width={267}
              height={348}
              style={{ borderRadius: "8px", objectFit: "cover" }}
            />
          </div>
          <div className={styles.socialsContainer}>
            {storefrontData.socialAccounts &&
              Object.keys(storefrontData.socialAccounts)
                .filter(
                  (item, index) =>
                    storefrontData.socialAccounts &&
                    storefrontData.socialAccounts[item as keyof CreatorSocialAccounts] !== null &&
                    storefrontData.socialAccounts[item as keyof CreatorSocialAccounts] !== "",
                )
                .map((key, index) => {
                  let socialUrl =
                    storefrontData.socialAccounts &&
                    storefrontData.socialAccounts[key as keyof CreatorSocialAccounts] &&
                    (storefrontData.socialAccounts[key as keyof CreatorSocialAccounts] || "");

                  const prefixUrl = socialsInfo[key as keyof CreatorSocialAccounts]["prefixUrl"];
                  const domain = socialsInfo[key as keyof CreatorSocialAccounts]["domain"];
                  if (!socialUrl?.includes(domain)) {
                    socialUrl = prefixUrl + socialUrl;
                  }

                  const CurrentIcon = socialsInfo[key as keyof CreatorSocialAccounts].icon;

                  return (
                    <a href={socialUrl} target="_blank" rel="noreferrer" key={index}>
                      <CurrentIcon fill={iconColor} />
                    </a>
                  );
                })}
          </div>
        </div>
        <div className={styles.authorTitleShort}>
          <div className={styles.authorHeader}>
            <ProfilePic
              className={styles.mobileAuthorImage}
              size={57}
              borderRadius={"50%"}
              imageUrl={storefrontData.welcomePosterImageURL}
              firstName={fieldsTexts["creatorName"]}
            />
            <div>
              <div
                className={styles.authorShortDes}
                style={{
                  color: authorShortDesColor,
                }}
              >
                meet your instructor
              </div>
              <div className={styles.authorTitle}>
                <div
                  className={classNames(
                    styles.titleText,
                    isInEditMode && productStyles.editableElement,
                  )}
                  contentEditable={isInEditMode}
                  suppressContentEditableWarning={true}
                  onBlur={(e) => handleTextChange(e, "creatorName", CreatorSavingType.STOREFRONT)}
                  onInput={(e) => handleTextEdit(e, "creatorName", CreatorSavingType.STOREFRONT)}
                  style={fieldsOnError.includes("creatorName") ? errorBorderStyle : undefined}
                >
                  {isInEditMode ? fieldsTexts["creatorName"] : storefrontData.creatorName}
                </div>
                <CreatorCheck />
              </div>
            </div>
          </div>

          {isInEditMode ? (
            <div className={styles.authorTextBlock}>
              <p
                ref={textBlockRef}
                className={classNames(
                  styles.authorText,
                  isInEditMode && productStyles.editableElement,
                )}
                contentEditable={isInEditMode}
                suppressContentEditableWarning={true}
                onBlur={(e) =>
                  handleTextChange(e, "storefrontDescription", CreatorSavingType.STOREFRONT)
                }
                onInput={(e) =>
                  handleTextEdit(e, "storefrontDescription", CreatorSavingType.STOREFRONT)
                }
                style={
                  fieldsOnError.includes("storefrontDescription") ? errorBorderStyle : undefined
                }
              >
                {fieldsTexts["storefrontDescription"]}
              </p>
            </div>
          ) : (
            <div className={styles.authorTextBlock} onClick={handleCLick}>
              <p ref={textBlockRef} className={classNames(styles.authorText)}>
                {/* {showMore && truncatedText.truncated
                  ? truncatedText.content
                  : storefrontData.description} */}
                {storefrontData.description}
              </p>
              {/* {showMore && truncatedText.truncated && (
                <span className={classNames(styles.authorTextShowMore)}>More</span>
              )}
              {!showMore && truncatedText.truncated && (
                <span className={styles.authorTextShowMore}>Less</span>
              )} */}
            </div>
          )}
        </div>
      </div>
      {/* {storefrontData && (
        <>
          <div className={styles.videoChapter}>
            <div className={styles.topicTitle}>All Classes ({productsLength})</div>
          </div>
          <div className={styles.videoList}>
            <div className={styles.carouselContainer}>
              <div>
                <div id="instructor-carousel">
                  <CarouselProvider
                    naturalSlideWidth={348}
                    naturalSlideHeight={555}
                    totalSlides={productsLength}
                    visibleSlides={visibleVideosSlidesForDevice(width)}
                    isIntrinsicHeight
                    dragEnabled={false}
                    currentSlide={currentSlide + 1}
                  >
                    <div
                      className={classNames(currentSlide === -1 ? "" : styles.gradientBlockLeft)}
                    ></div>
                    <div className={styles.gradientBlockRight}></div>
                    <div></div>
                    <button
                      className={classNames(
                        styles.navigationButton,
                        styles.buttonPrevious,
                        currentSlide === -1 && styles.arrowVisibility,
                      )}
                      onClick={() => setCurrentSlide(currentSlide - 1)}
                    >
                      <CarouselButtonPreviousIcon />
                    </button>

                    {shouldShowNextArrow && (
                      <button
                        className={classNames(
                          styles.navigationButton,
                          styles.buttonNext,
                          isLastCardVisible && styles.arrowVisibility,
                        )}
                        onClick={() => setCurrentSlide(currentSlide + 1)}
                      >
                        <CarouselButtonNextIcon />
                      </button>
                    )}
                    <Slider>
                      <div>
                        {products?.length &&
                          products.map((video: ProductData, i: number) => {
                            return (
                              <>
                                <Slide
                                  key={i}
                                  index={i}
                                  className={classNames(styles.videoSlide, "authorVideoSlide")}
                                  onClick={onCLickSlider}
                                >
                                  <VideoCard
                                    key={video.id}
                                    isForLibrary={false}
                                    video={video}
                                    isForProductPage={true}
                                  />
                                </Slide>
                                <div ref={lastCardContainerRef}></div>
                              </>
                            );
                          })}
                      </div>
                    </Slider>
                  </CarouselProvider>
                </div>
              </div>
            </div>
          </div>
        </>
      )} */}

      {/* <a href={"/classes/" + productData.storefrontSlug} target="__blank">
        <button className={styles.goToAuthorStudio}>
          {"Go to " + productData.creatorName + "'s Studio"}
        </button>
      </a> */}
    </section>
  );
};
